import React from "react";
import {
    MDBNavbarNav, MDBNavbarItem, MDBNavbarLink
} from "mdb-react-ui-kit";

const Navbar = () => {
    const [showNav, setShowNav] = React.useState(false);
    const pages = [
        {
            "icon": "🏠",
            "path": "/",
            "name": "Home"
        },
        {
            "icon": "🎟️",
            "path": "/coupons",
            "name": "Coupons"
        },
        {
            "icon": "🧾",
            "path": "/invoices",
            "name": "Invoices"
        },

        {
            "icon": "📩",
            "path": "/invite",
            "name": "Invites"
        },
        {
            "icon": "🌐",
            "path": "/landingPages",
            "name": "Landing Pages"
        },
        {
            "icon": "📝",
            "path": "/blog",
            "name": "Blog"
        }
    ]
    return (
        <div>
            <div role="button" onClick={() => setShowNav(!showNav)} style={{
                position: "fixed",
                top: 0,
                userSelect: "none",
                outline: "none",
                border: "2px solid",
                width: showNav ? "200px" : "60px",
                height: "40px",
                backgroundColor: "#e91e63",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "5px 10px",
                zIndex: 10000
            }}>
                {Array.from({ length: 3 }).map((_, i) => (
                    <p key={i} style={{
                        width: "30px",
                        height: "2px",
                        backgroundColor: "#fff",
                        marginBottom: "6px"
                    }}></p>
                ))}
            </div>
            {showNav && <div style={{
                position: "fixed", minHeight: "100vh", zIndex: 9999, backgroundColor: "#333", color: "#fff",
                width: "200px", padding: "40px 5px", margin: 0, textAlign: "left"
            }}>
                <MDBNavbarNav className="mb-2 mb-lg-0">
                    {pages.map((lnk) => (
                        <MDBNavbarItem key={lnk.name} style={{
                            color: `${window.location.pathname === lnk.path ? "#e91e63" : "auto"}`
                        }}>
                            <MDBNavbarLink href={lnk.path}>{lnk.icon} &nbsp;{lnk.name}</MDBNavbarLink>
                        </MDBNavbarItem>
                    ))}
                </MDBNavbarNav>
            </div>}
        </div>
    );
}
export default Navbar;